module.exports = __webpack_public_path__ + "static/media/img3-2.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/nutricheck_foliar/ZN/img3-2.png
// module id = 1614
// module chunks = 3